<template>
  <div class="wrap-group-simcard-list">
    <div class="row response_table">
      <table>
        <thead
          ref="tableHead"
          class="table-device-list_bg"
          :class="(filters_state)? 'device-list_fiters_is--show' : 'device-list_fiters_is--hidden'"
        >
          <tr>
            <th scope="col" class="status table-device-list_mob-filters">
              <toggle-switch-simcard-status
                v-model="filter_simcard.status"
                :disabled="false"
                :name="name"
                @toggle="change_status"
              />
            </th>
            <th scope="col" class="table-device-list_mob-filters">
              <tag-list-popup
                v-model="filter_simcard.name"
                :label="translate('simcard_devices.name')"
                @input="change_input"
              />
            </th>
            <th scope="col" class="table-device-list_mob-filters">
              <tag-list-popup
                v-model="filter_simcard.number"
                :label="translate('simcard_devices.number')"
                @input="change_input"
              />
            </th>
            <th scope="col" @click="active_simcard_sort()" class="table-simcard-list_mob-filters__traffic">
              {{ translate('simcard_devices.traffic') }}
              <i class="mdi mdi-arrow-down" :class="{'reverse' : sims_sort === 'desc'}"></i>
            </th>
            <th scope="col" class="table-device-list_mob-filters">
              <tag-list-popup
                v-model="filter_simcard.device_fid"
                :label="translate('simcard_devices.fid')"
                @input="change_input"
              />
            </th>
            <th scope="col" class="table-device-list_mob-filters">
              <tag-list-popup
                v-model="filter_simcard.imsi"
                :label="translate('simcard_devices.imsi')"
                @input="change_input"
              />
            </th>
            <th scope="col" class="table-device-list_mob-filters">
              <tag-list-popup
                v-model="filter_simcard.iccid"
                :label="translate('simcard_devices.iccid')"
                @input="change_input"
              />
            </th>
            <th style="width: 15px" />
          </tr>

          <tr>
            <th v-if="head_tr" class="group_res">
              {{ head_tr }}
            </th>
          </tr>
        </thead>
        <tbody ref="tableSimcard" style="position: relative" @scroll.passive="paint_chart($event)">
          <tr v-if="load" style="border:none; background-color:  transparent;">
            <td> <scale-loader /> </td>
          </tr>
          <EsimProfileListItem
            v-for="(item,index) in trs"
            ref="mySimcard"
            :key="index"
            :index="index"
            :item="item"
            :checkbox="item.checkbox"
          />
          <tr v-if="afterload" style="border:none; background-color:  transparent;" >
            <td> <scale-loader /> </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import EsimProfileListItem from '../EsimProfileList/EsimProfileListItem.vue'
import ToggleSwitchSimcardStatus from "components/UIComponents/ToggleSwitch/ToggleSwitchSimcardStatus.vue";
import TagListPopup from 'components/UIComponents/Tags/TagListPopup.vue'

export default {
  name: 'EsimProfileGroup',
  components: {
    EsimProfileListItem,
    ToggleSwitchSimcardStatus,
    TagListPopup
  },
  data () {
    return {
      sims_sort: 'asc',
      range: false,
      cur_item: {},
      load: true,
      top: 0,
      ids: [],
      interval_update: null,
      afterload: false,
      group_cnt: {},
      tableData: {},
      trs: [],
      timer: null,
      timer_res: null,
      name: '',
      cur_pages: 0,
      pages: 0,
      timer_chart: null,
      menuData: {},
      rendList: [],
      resizeList: [],
      filter_simcard: {},
      head_tr: '',
      group_head: [],
      group: [],
      status_option: [],
      filters_state: (this.localStorage.getItem('filters_state') !== null) ? (this.localStorage.getItem('filters_state') === 'true') : true
    }
  },
  computed: {
    group_id () {
      if ( this.$route.name === 'esim_devices_group' ) {
        return this.$route.params.esim_profile_group_id
      } else {
        return -1
      }

    },
    proveCopy () {
      return (navigator.clipboard !== undefined)
    }
  },

  watch: {
   group_id () {
     if (this.group_id !== -1) {
       this.filter_simcard.group = [this.group_id]
       this.tableData = []
       this.load = true
       this.get_simcard()
     }

   },
   tableData () {
      var trs = [] // 0 - название группы, 1 - элемент
      this.group_head = []

      for (let i in this.tableData) {
        for (let j in this.tableData[i]) {
          if ((this.online && this.tableData[i][j].status) || !this.online) {
            this.tableData[i][j].type = 1
            this.tableData[i][j].checkbox = false
            trs.push(this.tableData[i][j])
          }
        }
      }

      if (trs.length === 0) {
        this.head_tr = 'No result'
        this.trs = []
      } else {
        this.$set(this, 'trs', trs)
      }
      this.load = false
      this.afterload = false
      this.$nextTick(this.mountItem)
      return true
    }
  },
  created () {
    this.init()
    window.addEventListener('resize', this.handleResize)
  },

  activated () {
    this.$refs.tableSimcard.scrollTop = this.top
    if (this.$store.getters.getDeviceListChange) {
      this.init()
      this.$store.commit('getSimcardDevicesListChange', false)
    } else {
      clearInterval(this.interval_update)
      this.interval_update = setInterval(this.update_status, this.$store.getters.getEsimGroupUpdate)
    }

    window.addEventListener('resize', this.handleResize)
  },

  beforeDestroy: function () {
    window.removeEventListener('resize', this.handleResize)
  },

  deactivated () {
    this.top = this.$refs.tableSimcard.scrollTop
    clearInterval(this.interval_update)
    window.removeEventListener('resize', this.handleResize)
  },

  methods: {
    active_simcard_sort(){
      if (this.sims_sort === 'asc') {
        this.sims_sort = 'desc'
        this.trs.sort((a, b) => a.balance_trafic < b.balance_trafic ? 1 : -1)
      }else{
        this.sims_sort = 'asc'
        this.trs.sort((a, b) => a.balance_trafic > b.balance_trafic ? 1 : -1)
      }
    },
    update_status () {
      this.date = new Date()
      this.$http.v1.getPagesSimcards(this.filter_simcard, (response) => {
        this.page = response.data.pages
        this.group = response.data.group
        for (let i = 0; i <= this.cur_page; i++) {
          setTimeout(() => {
            this.$http.v1.getSimcardList({...this.filter_simcard, 'page': i}, (response) => {
              for (let i in response.data.sim) {
                if (this.tableData[i] === undefined) {
                  this.tableData[i] = {}
                }
                for (let j in response.data.sim[i]) {
                  if (this.tableData[i][j] === undefined) {
                    this.tableData[i][j] = {}
                  }
                  this.tableData[i][j] = response.data.sim[i][j]
                  this.tableData[i][j].offline = response.data.sim[i][j].offline
                }
              }
            })
          }, 300)
        }
      })
    },
    change_status (name, value) {
      this.filter_simcard.status[name] = value
      this.change_input()
    },

    handleResize () {
      if (this.timer_res !== null) {
        clearTimeout(this.timer_res)
      }
      this.timer_res = setTimeout(() => { this.resizeList = [...this.$refs.mysimcard]; this.paint_chart() }, 300)
    },
    status_filter () {
      for (let i in this.filter_simcard) {
        if (i === 'status') {
          for (let j in this.filter_simcard.status) {
            if (this.filter_simcard.status[j]) {
              return true
            }
          }
        } else {
          if (this.filter_simcard[i].length > 0) {
            return true
          }
        }
      }
      return false
    },

    init () {
      this.$store.dispatch('addLinkGroupSimcardDevices', this.group_id)
      this.filter_simcard = {name: [], group: [this.group_id], number: [], iccid: [], imsi: [], device_fid: [], status: { online: false, blocked: false, crit_traffic: false }}
      this.date = new Date()
    },

    paint_chart () {
      let tmpRend = []
      let table = this.$refs.tableSimcard
      for (let i in this.resizeList) {
        if ((this.resizeList[i].$el.offsetTop > (table.scrollTop - 40)) && this.resizeList[i].$el.offsetTop < (table.scrollTop + table.clientHeight + 40)) {
          if (this.resizeList[i].chartStatus === true) {
            this.resizeList[i].resize = !this.resizeList[i].resize
          }
        } else {
          tmpRend.push(this.resizeList[i])
        }
      }

      if (tmpRend.length > 0) {
        this.resizeList = [...tmpRend]
      }

      tmpRend = []
      for (let i in this.rendList) {
        if ((this.rendList[i].$el.offsetTop > (table.scrollTop - 40)) && this.rendList[i].$el.offsetTop < (table.scrollTop + table.clientHeight + 40)) {
          this.rendList[i].chartStatus = true
        } else {
          tmpRend.push(this.rendList[i])
        }
      }
      this.rendList = tmpRend
      if ((table.scrollTop >= table.scrollHeight - (table.clientHeight * 3)) && !this.afterload) {
        if (this.cur_page < this.pages) {
          this.add_simcard_in_list()
        }
      }
    },

    mountItem () {
      if (this.trs.length === 0) {
        return false
      }
      let length = (this.$refs.mySimcard.length < 25) ? this.$refs.mySimcard.length : 25

      for (let i = 0; i < length; i++) {
        this.$refs.mySimcard[i].chartStatus = true
      }
      if (length < this.$refs.mySimcard.length) {
        for (let i = 25; i < this.$refs.mySimcard.length; i++) {
          this.rendList.push(this.$refs.mySimcard[i])
        }
      }
    },
    change_input () {
      if (this.timer !== null) {
        clearTimeout(this.timer)
      }
      this.timer = setTimeout(this.get_simcard, 1000)
    },

    reset_filter () {
      this.filter_simcard = {name: [], group: [], number: [], iccid: [], imsi: [], device_fid: [], status: { online: false, blocked: false, crit_traffic: false }}
      this.change_input()
    },

    get_simcard () {
      this.ids = []
      this.load = true

      clearInterval(this.interval_update)
      this.interval_update = setInterval(this.update_status, this.$store.getters.getEsimGroupUpdate)

      this.rendList = []

      let filter_simcard = this.filter_simcard
      this.$http.v1.getPagesSimcards(filter_simcard, (response) => {
        this.pages = response.data.pages

        for (let group of response.data.group) {
          this.group_cnt[group.group_id] = group
        }
        // this.group_cnt = response.data.group

        this.hash = response.data.hash
        this.$http.v1.getSimcardList({...filter_simcard, 'page': this.cur_page = 0}, (response) => {
          this.tableData = {...response.data.sim}
          this.ids = [...response.data.ids]
        })
      })
    },

    add_simcard_in_list () {
      if (this.cur_page+1 < this.pages) {
        this.afterload = true
        this.$http.v1.getSimcardList({...this.filter_simcard, 'page': ++this.cur_page}, (response) => {
          let tmp = {...this.tableData}
          for (let i in response.data.sim) {
            if (tmp[i] === undefined) {
              tmp[i] = {}
            }
            for (let j in response.data.sim[i]) {
              tmp[i][j] = response.data.sim[i][j]
            }
          }
          this.tableData = {...tmp}
          this.ids = [...this.ids, ...response.data.ids]
        })
      }
    },
    toggleFiltersState () {
      this.filter_simcards_state = !this.filter_simcards_state
      this.localStorage.setItem('filters_state', this.filter_simcards_state)
    }
  }
}
</script>

<style scoped>
.wrap-group-simcard-list{
  height: 100%;
}

</style>
